import { createSlice } from "@reduxjs/toolkit";

// Create a Redux slice for handling sidebar-related state
const sidebarSlice = createSlice({
  name: "sidebar", // Name of the slice
  initialState: {
    activeItem: "Home", // The initial active item in the sidebar (default is "Home")
  },
  reducers: {
    // Reducer to set the active item in the sidebar
    setActiveItem: (state, action) => {
      state.activeItem = action.payload; // Update the activeItem with the provided payload
    },
  },
});

export const { setActiveItem } = sidebarSlice.actions;

export default sidebarSlice.reducer;
